<div class="bolt-container">
  @for (report of reportDetails; track report.driverName) {
    <div class="bolt-background-ultralightGray report-container">
      <div
        class="bolt-row bolt-justify-content-between bolt-space-inner-wide-xl"
        >
        <div class="bolt-col-10 reports-details">
          <img
            class="product-image"
            src="assets/images/icons/person-circle-colorized.svg"
            />{{ report.driverName }}
          </div>
          <div class="bolt-col-2">
            @if (report.status === 'Clean') {
              <div class="reports-icon">
                <bolt-icon
                  name="checkmark-circle-filled"
                  color="theme-success"
                ></bolt-icon>
                &nbsp;&nbsp;Clear
              </div>
            }
            @if (report.status !== 'Clean') {
              <div class="reports-icon">
                <bolt-icon
                  name="exclamation-triangle-filled"
                  color="theme-warning"
                  ></bolt-icon
                  >&nbsp;&nbsp;Adverse
                </div>
              }
            </div>
          </div>
          @for (incident of report.incidents; track $index) {
            <div class="bolt-row mvr-item bolt-background-white">
              <div class="bolt-col-6 bolt-col-lg-3">
                <strong>{{ incident.type.toUpperCase() }}</strong>
              </div>
              <div class="bolt-col-6 bolt-col-lg-9">{{ incident.description }}</div>
              <div class="bolt-col-xs-6 bolt-col-lg-3"><strong>Violation/suspension date</strong></div>
              <div class="bolt-col-xs-6 bolt-col-lg-9">{{ incident.violationSuspensionDate }}</div>
              <div class="bolt-col-xs-6 bolt-col-lg-3">
                <strong>Conviction/reinstatement date</strong>
              </div>
              <div class="bolt-col-xs-6 bolt-col-lg-9">{{ incident.convictionReinstatementDate }}</div>
            </div>
          }
        </div>
      }
    </div>
